module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.toolbarLoading),
      expression: "toolbarLoading"
    }],
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "コンテンツ種別"
    },
    model: {
      value: (_vm.filters.user),
      callback: function($$v) {
        _vm.$set(_vm.filters, "user", $$v)
      },
      expression: "filters.user"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allUsers), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "コンテンツ名（部分一致）"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getContents
    }
  }, [_vm._v("検索")]), _vm._v(" "), (_vm.adminRole) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportCsv
    }
  }, [_vm._v("CSV出力")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新規追加")])], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 30,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.contents,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "コンテンツ種別",
      "width": "160",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "コンテンツ名",
      "width": "300",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "paidFlag",
      "label": "コンテンツ有償・無償",
      "width": "200",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.getPaidFlagName(scope.row.paidFlag)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "URL",
      "width": "600"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                smps-app://5g?type=interactive&contentsid=" + _vm._s(scope.row.id) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.copyUrl(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publishBegin",
      "label": "公開日時",
      "width": "300",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(scope.row.publishBegin)) + " - " + _vm._s(_vm._f("formatDate")(scope.row.publishEnd)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fiveGChannelId",
      "label": "5GチャンネルID",
      "width": "210",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.fiveGChannelId) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updatedAt",
      "label": "更新日時",
      "width": "210",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(scope.row.updatedAt)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("編集")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("削除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("一括削除")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "編集",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeEditForm
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "ID",
      "prop": "id"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "id", $$v)
      },
      expression: "editForm.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "コンテンツ名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "説明文",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.editForm.description),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "description", $$v)
      },
      expression: "editForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "動画1",
      "prop": "mainMovieId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "動画1",
      "value-key": "id"
    },
    model: {
      value: (_vm.editForm.mainMovieId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mainMovieId", $$v)
      },
      expression: "editForm.mainMovieId"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allMovies), function(item) {
    return (item.status == 'completed') ? _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": _vm.formatMovieName(item.name, item.mode, item.contents)
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "動画2",
      "prop": "mainMovieId2"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "動画2"
    },
    model: {
      value: (_vm.editForm.mainMovieId2),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mainMovieId2", $$v)
      },
      expression: "editForm.mainMovieId2"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allMovies), function(item) {
    return (item.status == 'completed') ? _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": _vm.formatMovieName(item.name, item.mode, item.contents)
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "優先順位",
      "prop": "priority"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.editForm.priority),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "priority", $$v)
      },
      expression: "editForm.priority"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公開日時"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "開始日時",
      "format": "yyyy/MM/dd HH:mm"
    },
    model: {
      value: (_vm.editForm.publishBegin),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "publishBegin", $$v)
      },
      expression: "editForm.publishBegin"
    }
  }), _vm._v("\n                〜\n                "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "終了日時",
      "format": "yyyy/MM/dd HH:mm"
    },
    model: {
      value: (_vm.editForm.publishEnd),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "publishEnd", $$v)
      },
      expression: "editForm.publishEnd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "シリーズ"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "選択して下さい"
    },
    model: {
      value: (_vm.editForm.seriesId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "seriesId", $$v)
      },
      expression: "editForm.seriesId"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allSeries), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "カテゴリ",
      "prop": "relationCategories"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "選択して下さい"
    },
    model: {
      value: (_vm.editForm.relationCategories),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "relationCategories", $$v)
      },
      expression: "editForm.relationCategories"
    }
  }, _vm._l((_vm.allCategories), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "コンテンツ種別",
      "prop": "users"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "選択して下さい"
    },
    model: {
      value: (_vm.editForm.users),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "users", $$v)
      },
      expression: "editForm.users"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allUsers), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "画像",
      "prop": "imageId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "選択して下さい",
      "value-key": "id"
    },
    model: {
      value: (_vm.editForm.imageId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "imageId", $$v)
      },
      expression: "editForm.imageId"
    }
  }, _vm._l((_vm.allImages), function(image) {
    return _c('el-option', {
      key: image.id,
      attrs: {
        "value": image.id,
        "label": image.name
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.editForm.contentsId) ? _c('el-form-item', {
    attrs: {
      "label": "コンテンツID",
      "prop": "contentsId"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.contentsId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "contentsId", $$v)
      },
      expression: "editForm.contentsId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("スマパスアプリ専用項目")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "スマパスNo",
      "prop": "cinnamonContentsId"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": _vm.isDisable
    },
    model: {
      value: (_vm.editForm.cinnamonContentsId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cinnamonContentsId", $$v)
      },
      expression: "editForm.cinnamonContentsId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "コンテンツ有償無償",
      "prop": "paidFlag"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.paidFlag),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "paidFlag", $$v)
      },
      expression: "editForm.paidFlag"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("有償")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("無償")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "5GチャンネルID",
      "prop": "fiveGChannelId"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.fiveGChannelId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "fiveGChannelId", $$v)
      },
      expression: "editForm.fiveGChannelId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作成日時"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "作成日時",
      "format": "yyyy/MM/dd HH:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.createdAt),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "createdAt", $$v)
      },
      expression: "editForm.createdAt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "更新日時"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "更新日時",
      "format": "yyyy/MM/dd HH:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "updatedAt", $$v)
      },
      expression: "editForm.updatedAt"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditForm($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("登録")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新規追加",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeAddForm
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "コンテンツ名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "説明文",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.addForm.description),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "description", $$v)
      },
      expression: "addForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "動画1",
      "prop": "mainMovieId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "動画1"
    },
    model: {
      value: (_vm.addForm.mainMovieId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mainMovieId", $$v)
      },
      expression: "addForm.mainMovieId"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allMovies), function(item) {
    return (item.status == 'completed') ? _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": _vm.formatMovieName(item.name, item.mode, item.contents)
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "動画2",
      "prop": "mainMovieId2"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "動画2"
    },
    model: {
      value: (_vm.addForm.mainMovieId2),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mainMovieId2", $$v)
      },
      expression: "addForm.mainMovieId2"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allMovies), function(item) {
    return (item.status == 'completed') ? _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": _vm.formatMovieName(item.name, item.mode, item.contents)
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "優先順位",
      "prop": "priority"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.addForm.priority),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "priority", $$v)
      },
      expression: "addForm.priority"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公開日時"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "開始日時",
      "format": "yyyy-MM-dd HH:mm"
    },
    model: {
      value: (_vm.addForm.publishBegin),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "publishBegin", $$v)
      },
      expression: "addForm.publishBegin"
    }
  }), _vm._v("\n                〜\n                "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "終了日時",
      "format": "yyyy-MM-dd HH:mm"
    },
    model: {
      value: (_vm.addForm.publishEnd),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "publishEnd", $$v)
      },
      expression: "addForm.publishEnd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "シリーズ"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "選択して下さい"
    },
    model: {
      value: (_vm.addForm.seriesId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "seriesId", $$v)
      },
      expression: "addForm.seriesId"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allSeries), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "カテゴリ",
      "prop": "relationCategories"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "選択して下さい"
    },
    model: {
      value: (_vm.addForm.relationCategories),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "relationCategories", $$v)
      },
      expression: "addForm.relationCategories"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allCategories), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "コンテンツ種別",
      "prop": "users"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "選択して下さい"
    },
    model: {
      value: (_vm.addForm.users),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "users", $$v)
      },
      expression: "addForm.users"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allUsers), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "画像",
      "prop": "imageId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "選択して下さい",
      "value-key": "id"
    },
    model: {
      value: (_vm.addForm.imageId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "imageId", $$v)
      },
      expression: "addForm.imageId"
    }
  }, _vm._l((_vm.allImages), function(image) {
    return _c('el-option', {
      key: image.id,
      attrs: {
        "value": image.id,
        "label": image.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("スマパスアプリ専用項目")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "スマパスNo",
      "prop": "cinnamonContentsId"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.cinnamonContentsId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "cinnamonContentsId", $$v)
      },
      expression: "addForm.cinnamonContentsId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "コンテンツ有償無償",
      "prop": "paidFlag"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.paidFlag),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "paidFlag", $$v)
      },
      expression: "addForm.paidFlag"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("有償")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("無償")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeAddForm($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("登録")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-360ea1d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contents/List.vue
// module id = 1136
// module chunks = 1